var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app","data-replay-blocked":_vm.replayBlocked}},[_c('six-header'),_c('router-view'),_c('six-toast-container'),_c('consent-preferences')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }